interface VerticalSeparatorProps {
  text?: string;
}

export default function VerticalSeparator({ text }: VerticalSeparatorProps) {
  return (
<div className="relative flex flex-row gap-2 items-center">
<div className="w-full border-t border-eoe-border-main dark:border-eoe-dark-border-main" />
<div className="relative flex flex-row flex-nowrap flex-shrink-0 justify-center text-sm">
  <span className="bg-transparent text-eoe-text-sub dark:text-eoe-dark-text-sub">
    {text || "OR"}
  </span>
</div>
<div className="w-full border-t border-eoe-border-main dark:border-eoe-dark-border-main" />
</div>
  );
}